import 'components/util/ez-carousel/ez-carousel';

import './tags-carousel.css';
